export default __webpack_public_path__ + "static/Starbust6-9b5feae651207afd79db9c4598f56e0c.png";